import { render, staticRenderFns } from "./back-icon-button.vue?vue&type=template&id=24d532dd"
import script from "./back-icon-button.vue?vue&type=script&lang=js"
export * from "./back-icon-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports